var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag.label)?_c('a-tag',{staticClass:"availability-label",class:("availability-label--" + (_vm.tag.type)),attrs:{"color":_vm.tag.color}},[_vm._v(" "+_vm._s(_vm.tag.label)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }